import { render, staticRenderFns } from "./AppRecommendProducts.vue?vue&type=template&id=2d051e44"
import script from "./AppRecommendProducts.vue?vue&type=script&lang=js"
export * from "./AppRecommendProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports